var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCollapse35 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 35,
  height: 35,
  viewBox: "0 0 35 35",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 17.5C3 9.49187 9.49187 3 17.5 3C25.5081 3 32 9.49187 32 17.5C32 25.5081 25.5081 32 17.5 32C9.49187 32 3 25.5081 3 17.5ZM17.5 2C8.93959 2 2 8.93959 2 17.5C2 26.0604 8.93959 33 17.5 33C26.0604 33 33 26.0604 33 17.5C33 8.93959 26.0604 2 17.5 2ZM10.5 17C10.2239 17 10 17.2239 10 17.5C10 17.7761 10.2239 18 10.5 18H24.5C24.7761 18 25 17.7761 25 17.5C25 17.2239 24.7761 17 24.5 17H10.5Z",
  fill: "currentColor"
})));
export default SvgCollapse35;